var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBetsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3a1 1 0 011 1v16a1 1 0 01-1 1h-.52a1 1 0 01-.78-.375l-1.236-1.545a.1.1 0 00-.143-.015l-1.62 1.35a1 1 0 01-1.347-.06L12.07 19.07a.1.1 0 00-.14 0l-1.284 1.285a1 1 0 01-1.347.06l-1.62-1.35a.1.1 0 00-.143.015L6.3 20.625a1 1 0 01-.78.375H5a1 1 0 01-1-1V4a1 1 0 011-1h14zM8 11.25a.75.75 0 000 1.5h4a.75.75 0 000-1.5H8zm0-4a.75.75 0 000 1.5h8a.75.75 0 000-1.5H8z",
    fill: "currentColor"
  })));
}
SvgMyBetsFilled.displayName = 'MyBetsFilled';
export default SvgMyBetsFilled;